import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";

interface IShuttleConfig {
  capicity: number;
  minutes: number;
  hours: number;
}

export const useGetCapacity = () => {
  const { user, siteId } = useAuth();
  const [getRecords] = useLazyReadMultipleQuery();
  const [capacities, setCapacity] = useState<IShuttleConfig | null>(null);

  useEffect(() => {
    getCapacities();
    // eslint-disable-next-line
  }, [user]);

  const getCapacities = (): Promise<void> => {
    return getRecords({
      userId: user?.contactId || user?.entityId,
      portalId: siteId || '',
      tableId: "slcm_configurator",
      fieldList: [
        "edtec365_seatsperbookingallowed",
        "edtec365_shuttleminutesforbooking",
        "edtec365_shuttlehoursforbooking"
      ],
      filters: [
        {
          group: 0,
          filters: [
            { field: "slcm_name", type: FieldFilterType.Const, value: "Shuttle Booking Configurator" }
          ]
        }
      ]
    })
      .unwrap()
      .then((data) => {
        const record = data.records[0];

        if (record) {
          const shuttleConfig: IShuttleConfig = {
            capicity: record["edtec365_seatsperbookingallowed"] as number,
            minutes: record["edtec365_shuttleminutesforbooking"] as number,
            hours: record["edtec365_shuttlehoursforbooking"] as number,
          };
          setCapacity(shuttleConfig);
        }
      });
  };

  return { capacities };
};
